import React from 'react'

export default () => (
  <svg
    className="PasswordSVG"
    fill="none"
    height="106"
    viewBox="0 0 106 106"
    width="106"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <circle cx="53" cy="53" fill="#3728AA" r="40" />
      <mask height="111" id="mask0" maskUnits="userSpaceOnUse" width="110" x="-1" y="-3">
        <circle
          cx="53.8982"
          cy="52.4276"
          fill="#FFDCCC"
          r="38.8498"
          transform="rotate(-48.66 53.8982 52.4276)"
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          d="M47.1381 49.4531C51.0231 48.4818 54.2749 45.4517 54.9081 44.5969M49.5231 -17.8941C37.8182 -10.0747 63.0939 4.26247 65.8992 18.0566C66.9988 23.4635 66.6162 28.8346 64.1349 33.9132"
          stroke="#E2D4F7"
          strokeLinecap="round"
          strokeWidth="3"
        />
        <mask fill="white" id="path-4-inside-1">
          <path
            clipRule="evenodd"
            d="M72.9159 50.6599C73.6607 43.6025 69.6915 36.6239 62.7777 33.8564C54.4361 30.5173 44.967 34.5727 41.628 42.9143C38.2889 51.2559 42.3442 60.7249 50.6858 64.064C57.5992 66.8314 65.2871 64.5196 69.6178 58.8982L97.0537 69.8805C97.8382 70.1946 98.6345 69.4542 98.3782 68.649L95.5354 59.7143L91.5466 61.4808L90.5333 57.712L86.5445 59.4785L85.5313 55.7097L81.5425 57.4763L80.5292 53.7075L72.9159 50.6599ZM54.8113 41.8193C57.8447 43.0335 59.3193 46.4768 58.1051 49.5101C56.8909 52.5434 53.4476 54.0181 50.4143 52.8039C47.381 51.5897 45.9063 48.1464 47.1205 45.1131C48.3347 42.0798 51.778 40.6051 54.8113 41.8193Z"
            fillRule="evenodd"
          />
        </mask>
        <path
          d="M72.9159 50.6599L71.9214 50.5549L71.842 51.3072L72.5442 51.5883L72.9159 50.6599ZM69.6178 58.8982L69.9894 57.9698L69.2872 57.6887L68.8256 58.2879L69.6178 58.8982ZM97.0537 69.8805L96.6821 70.8089L97.0537 69.8805ZM98.3782 68.649L97.4253 68.9522L98.3782 68.649ZM95.5354 59.7143L96.4883 59.4111L96.1501 58.3483L95.1304 58.7999L95.5354 59.7143ZM91.5466 61.4808L90.5808 61.7404L90.884 62.8679L91.9515 62.3951L91.5466 61.4808ZM90.5333 57.712L91.499 57.4524L91.1959 56.3249L90.1284 56.7977L90.5333 57.712ZM86.5445 59.4785L85.5788 59.7382L85.8819 60.8656L86.9494 60.3929L86.5445 59.4785ZM85.5313 55.7097L86.497 55.4501L86.1939 54.3226L85.1263 54.7954L85.5313 55.7097ZM81.5425 57.4763L80.5768 57.7359L80.8799 58.8634L81.9474 58.3906L81.5425 57.4763ZM80.5292 53.7075L81.495 53.4478L81.3651 52.9649L80.9009 52.7791L80.5292 53.7075ZM73.9103 50.7649C74.701 43.2742 70.4894 35.8662 63.1493 32.928L62.4061 34.7848C68.8935 37.3816 72.6205 43.9307 71.9214 50.5549L73.9103 50.7649ZM63.1493 32.928C54.295 29.3837 44.2439 33.6883 40.6996 42.5426L42.5563 43.2859C45.6902 35.457 54.5772 31.6509 62.4061 34.7848L63.1493 32.928ZM40.6996 42.5426C37.1553 51.397 41.4599 61.4481 50.3142 64.9924L51.0575 63.1356C43.2286 60.0018 39.4225 51.1148 42.5563 43.2859L40.6996 42.5426ZM50.3142 64.9924C57.6539 67.9304 65.8134 65.475 70.41 59.5085L68.8256 58.2879C64.7607 63.5642 57.5446 65.7323 51.0575 63.1356L50.3142 64.9924ZM97.4253 68.9522L69.9894 57.9698L69.2462 59.8266L96.6821 70.8089L97.4253 68.9522ZM97.4253 68.9522L97.4253 68.9522L96.6821 70.8089C98.2511 71.437 99.8436 69.9563 99.3312 68.3457L97.4253 68.9522ZM94.5824 60.0175L97.4253 68.9522L99.3312 68.3457L96.4883 59.4111L94.5824 60.0175ZM91.9515 62.3951L95.9403 60.6286L95.1304 58.7999L91.1416 60.5665L91.9515 62.3951ZM89.5676 57.9716L90.5808 61.7404L92.5123 61.2212L91.499 57.4524L89.5676 57.9716ZM86.9494 60.3929L90.9383 58.6264L90.1284 56.7977L86.1396 58.5642L86.9494 60.3929ZM84.5656 55.9694L85.5788 59.7382L87.5102 59.2189L86.497 55.4501L84.5656 55.9694ZM81.9474 58.3906L85.9362 56.6241L85.1263 54.7954L81.1375 56.5619L81.9474 58.3906ZM79.5635 53.9671L80.5768 57.7359L82.5082 57.2166L81.495 53.4478L79.5635 53.9671ZM72.5442 51.5883L80.1576 54.6358L80.9009 52.7791L73.2875 49.7315L72.5442 51.5883ZM59.0335 49.8818C60.453 46.3357 58.729 42.3104 55.183 40.8909L54.4397 42.7477C56.9603 43.7567 58.1857 46.6179 57.1767 49.1385L59.0335 49.8818ZM50.0427 53.7323C53.5887 55.1517 57.6141 53.4278 59.0335 49.8818L57.1767 49.1385C56.1678 51.6591 53.3065 52.8845 50.7859 51.8755L50.0427 53.7323ZM46.1922 44.7415C44.7727 48.2875 46.4966 52.3128 50.0427 53.7323L50.7859 51.8755C48.2654 50.8666 47.04 48.0053 48.0489 45.4847L46.1922 44.7415ZM55.183 40.8909C51.6369 39.4715 47.6116 41.1954 46.1922 44.7415L48.0489 45.4847C49.0579 42.9641 51.9191 41.7387 54.4397 42.7477L55.183 40.8909Z"
          fill="#FF7433"
          mask="url(#path-4-inside-1)"
        />
        <line
          stroke="#FF7433"
          strokeLinecap="round"
          x1="70.2555"
          x2="91.2963"
          y1="56.3178"
          y2="64.7403"
        />
        <line
          stroke="#FF7433"
          strokeLinecap="round"
          x1="71.1109"
          x2="78.421"
          y1="54.1779"
          y2="57.1041"
        />
      </g>
      <path
        clipRule="evenodd"
        d="M30.377 51.6216L58.2533 33.6661L71.2446 53.8354L61.6621 60.0076L72.4334 76.7306L71.0072 80.5759L75.4996 81.4908L74.0733 85.3362L78.5657 86.2511L77.1394 90.0964L81.6318 91.0113L77.9495 102.516L53.8218 65.0576L43.3682 71.7909L30.377 51.6216ZM53.123 43.1939L41.4501 50.7126L44.546 55.5191L56.219 48.0005L53.123 43.1939Z"
        fill="#FF9666"
        fillRule="evenodd"
      />
      <rect
        height="8.49625"
        stroke="#140B41"
        strokeLinecap="round"
        transform="rotate(-32.786 39.0918 50.5833)"
        width="17.6461"
        x="39.0918"
        y="50.5833"
      />
      <line
        stroke="#140B41"
        strokeLinecap="round"
        x1="56.7966"
        x2="76.0736"
        y1="63.8727"
        y2="93.801"
      />
      <line
        stroke="#140B41"
        strokeLinecap="round"
        x1="58.9958"
        x2="67.3019"
        y1="62.4572"
        y2="75.3526"
      />
      <path
        d="M48.5972 48.9673C43.9659 50.7412 34.801 51.1324 26.2829 49.7429C17.7649 48.3534 10.5584 43.316 8.76431 40.8138C0.2472 28.9352 15.7501 14.8684 27.903 25.0972C37.5255 33.6508 6.85758 37.0727 5.85938 1.86206"
        stroke="#E2D4F7"
        strokeLinecap="round"
        strokeWidth="3"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect fill="white" height="106" width="106" />
      </clipPath>
    </defs>
  </svg>
)
